/**
 * Utility functions for NotificationDetail
 */

import type { Notification } from '../../../api/notificationApi';

/** Format date for display */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Extract and format content sections from notification */
export function parseNotificationContent(notification: Notification) {
  const payload = notification.payload as any;

  const title = payload.title || 'Untitled';
  const rawDescription: string =
    payload.description ?? payload.info ?? payload.message ?? '';

  // Extract "Sent by: <ref>" from the first line if present
  let sentBy: string | undefined;
  let description = rawDescription;
  const sentByMatch = rawDescription.match(/^Sent by:\s*(.+?)(\n|$)/);
  if (sentByMatch) {
    sentBy = sentByMatch[1].trim();
    // Strip the "Sent by: ..." line (and any leading blank lines after it)
    description = rawDescription
      .slice(sentByMatch[0].length)
      .replace(/^\s*\n/, '')
      .trimStart();
  }

  return { title, description, sentBy };
}
